import React, { useState } from 'react';

import * as api from '../../api';
import { type ErrorMessage } from '../../models';

import OtpForm from './OtpForm';

interface SentOtpFormProps {
  sentFactorType: 'email' | 'sms';

  /** Fired when the code is successfully verified */
  onSuccess: () => void;

  /** Fired when the code verification fails */
  onFailure: () => void;

  /** Whether the form should be submitted */
  isVerificationRequested: boolean;

  /** Fired when the form becomes submittable or not */
  onSubmittableChange: (state: boolean) => void;
}

export default function SentOtpForm({
  sentFactorType,
  onFailure: handleFailure,
  onSuccess: handleSuccess,
  isVerificationRequested,
  onSubmittableChange: handleSubmittableChange,
}: SentOtpFormProps) {
  const [isReadyToVerify, setIsReadyToVerify] = useState(false);

  const handleMount = async () => {
    await api.sendOtpCode(sentFactorType);
    setIsReadyToVerify(true);
  };

  const handleVerify = async (code: string): Promise<boolean | ErrorMessage> =>
    api.validateOtpCode(code, sentFactorType);

  return (
    <OtpForm
      onMount={handleMount}
      isReadyToVerify={isReadyToVerify}
      isVerificationRequested={isVerificationRequested}
      onVerify={handleVerify}
      onSuccess={handleSuccess}
      onFailure={handleFailure}
      onSubmittableChange={handleSubmittableChange}
    />
  );
}
